"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EWeight = exports.EMeasure = void 0;
var EMeasure;
(function (EMeasure) {
    EMeasure["CM"] = "CENTIMETERS";
    EMeasure["M"] = "METERS";
})(EMeasure || (exports.EMeasure = EMeasure = {}));
var EWeight;
(function (EWeight) {
    EWeight["G"] = "GRAMS";
    EWeight["KG"] = "KILOGRAMS";
})(EWeight || (exports.EWeight = EWeight = {}));
//# sourceMappingURL=dimension.js.map